// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../../core/resource.mjs";
import { ArrayPage } from "../../core/pagination.mjs";
import { path } from "../../internal/utils/path.mjs";
export class Messages extends APIResource {
    /**
     * Send a message to a conversation and get a response.
     *
     * This endpoint sends a message to an existing conversation. By default
     * (streaming=true), returns a streaming response (Server-Sent Events). Set
     * streaming=false to get a complete JSON response.
     *
     * **Agent-direct mode**: Pass conversation_id="default" with agent_id in request
     * body to send messages to the agent's default conversation with locking.
     *
     * **Deprecated**: Passing an agent ID as conversation_id still works but will be
     * removed.
     */
    create(conversationID, body, options) {
        return this._client.post(path `/v1/conversations/${conversationID}/messages`, {
            body,
            ...options,
            stream: true,
        });
    }
    /**
     * List all messages in a conversation.
     *
     * Returns LettaMessage objects (UserMessage, AssistantMessage, etc.) for all
     * messages in the conversation, with support for cursor-based pagination.
     *
     * **Agent-direct mode**: Pass conversation_id="default" with agent_id parameter to
     * list messages from the agent's default conversation.
     *
     * **Deprecated**: Passing an agent ID as conversation_id still works but will be
     * removed.
     */
    list(conversationID, query = {}, options) {
        return this._client.getAPIList(path `/v1/conversations/${conversationID}/messages`, (ArrayPage), { query, ...options });
    }
    /**
     * Compact (summarize) a conversation's message history.
     *
     * This endpoint summarizes the in-context messages for a specific conversation,
     * reducing the message count while preserving important context.
     *
     * **Agent-direct mode**: Pass conversation_id="default" with agent_id in request
     * body to compact the agent's default conversation messages.
     *
     * **Deprecated**: Passing an agent ID as conversation_id still works but will be
     * removed.
     */
    compact(conversationID, body = {}, options) {
        return this._client.post(path `/v1/conversations/${conversationID}/compact`, { body, ...options });
    }
    /**
     * Resume the stream for the most recent active run in a conversation.
     *
     * This endpoint allows you to reconnect to an active background stream for a
     * conversation, enabling recovery from network interruptions.
     *
     * **Agent-direct mode**: Pass conversation_id="default" with agent_id in request
     * body to retrieve the stream for the agent's most recent active run.
     *
     * **Direct run access**: Pass run_id directly to skip run lookup entirely. Useful
     * for recovery from duplicate request 409 errors.
     *
     * **OTID lookup**: Pass otid to look up the run_id from Redis. Useful when you
     * have the otid from a 409 error response.
     *
     * **Deprecated**: Passing an agent ID as conversation_id still works but will be
     * removed.
     */
    stream(conversationID, body = {}, options) {
        return this._client.post(path `/v1/conversations/${conversationID}/stream`, {
            body,
            ...options,
            stream: true,
        });
    }
}
//# sourceMappingURL=messages.mjs.map